// From: https://blog.logrocket.com/react-pagination-scratch-hooks/
import { useRouter } from 'next/router'
import { useEffect, useMemo } from 'react'

const INITIAL_PARAMS: { offset: number; page: number } = {
  offset: 0,
  page: 1
}

export const usePagination = (props?: { limit?: number }) => {
  const { limit = 10 } = props || {}

  const router = useRouter()

  const paginationParamsObj = useMemo(
    () => ({
      limit: parseInt(router.query.limit as string, 10),
      offset: parseInt(router.query.offset as string, 10),
      page: parseInt(router.query.page as string, 10)
    }),
    [router.query]
  )

  useEffect(() => {
    if (!router.query.limit || !router.query.offset || !router.query.page) {
      const params = { ...INITIAL_PARAMS, limit }

      Object.entries(params).forEach(([paramKey, paramVal]: any) => {
        router.query[paramKey] = paramVal
      })

      router.replace(
        { pathname: router.pathname, query: router.query },
        undefined,
        { shallow: true }
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query])

  const onPageClick = (pageNumber: number) => {
    const offset =
      pageNumber && paginationParamsObj?.limit
        ? (pageNumber - 1) * paginationParamsObj.limit
        : 0
    router.query.offset = `${offset}`
    router.query.page = `${pageNumber}`
    router.push({ pathname: router.pathname, query: router.query }, undefined, {
      shallow: true
    })
  }

  const resetPagination = () => {
    delete router.query.limit
    delete router.query.offset
    delete router.query.page

    router.push({ pathname: router.pathname, query: router.query }, undefined, {
      shallow: true
    })
  }

  return {
    currentPage: paginationParamsObj.page || INITIAL_PARAMS.page,
    limit: paginationParamsObj.limit || limit,
    offset: paginationParamsObj.offset || INITIAL_PARAMS.offset,
    onPageClick,
    resetPagination
  }
}
